import React, { useState, useEffect, useContext } from "react";
import DashboardLayout from "../../layoutcontainers/DashboardLayout";
import MaterialDataGrid from "../../components/MaterialDataGrid";
import MaterialTypography from "../../components/MaterialTypography";
import {
  AppBar,
  Autocomplete,
  Badge,
  Card,
  CardHeader,
  Grid2,
  Stack,
  styled,
  Tab,
  Tabs,
  TextField,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import MaterialButton from "../../components/MaterialButton";
import AddIcon from "@mui/icons-material/Add";
import BASEURL from "../Utils/Baseurl";
import axios from "axios";
import MaterialBox from "../../components/MaterialBox";
import breakpoints from "../../assest/theme/base/breakpoints";
import UserDetailsContext from "../../context/auth";
import { fetchAll } from "../../ApiBaseUrl";
import MaterialInput from "../../components/MaterialInput";
import useBranchAccess from "../../hooks/useBranchAccess";

//CSS for material UI Badge
const StyledBadge = styled(Badge)(({ theme }) => ({
  "& .MuiBadge-badge": {
    right: -1,
    top: -6,
    border: `2px solid ${theme.palette.background.paper}`,
    padding: "0 4px",
  },
}));

const EmployeeManagement = () => {
  const { isBranchAdmin, userBranch } = useBranchAccess();
  //pages
  const [totalCount, setTotalCount] = useState(0);

  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });
  const [categoriesOptions, setcategoriesOptions] = useState([]);

  const [branchOptions, setbranchOptions] = useState([]);
  const [shiftOptions, setShiftOptions] = useState([]);
  const [employeeTypeOptions] = useState([
    { value: "Staff", label: "Staff" },
    { value: "Operator", label: "Operator" },
  ]);

  const [categories, setcategories] = useState([]);

  const [emplyoee, setEmployee] = useState("");

  const [branches, setbranches] = useState([]);
  const [shifts, setShifts] = useState([]);
  const [employeeTypes, setEmployeeTypes] = useState([]);

  const navigate = useNavigate();
  const { user, AccessData, setEmpSubmit } = useContext(UserDetailsContext);

  const [pageState, setPageState] = useState({
    loading: false,
    error: false,
    message: "",
    state: "init",
  });
  const [userDetails, setUserDetails] = useState({
    department: "",
    designation: "",
    employeeType: "",
  });
  const [roledata, setroledata] = useState([]);
  const [tabsOrientation, setTabsOrientation] = useState("horizontal");
  const [tabValue, setTabValue] = useState(0);
  const [employeeList, setEmployeeList] = useState([]);

  useEffect(() => {
    if (isBranchAdmin) setbranches([userBranch]);
  }, [isBranchAdmin, userBranch]);

  useEffect(() => {
    if (isBranchAdmin && (!branches || branches.length === 0)) return;
    onEmployeeeSubmit();
    getroles();
  }, [paginationModel, isBranchAdmin, branches]);

  useEffect(() => {
    if (isBranchAdmin && (!branches || branches.length === 0)) return;
    onEmployeeeSubmit();
  }, [branches, categories, shifts, employeeTypes, paginationModel, emplyoee, isBranchAdmin]);

  useEffect(() => {
    function handleTabsOrientation() {
      return window.innerWidth < breakpoints.values.sm
        ? setTabsOrientation("vertical")
        : setTabsOrientation("horizontal");
    }

    window.addEventListener("resize", handleTabsOrientation);

    handleTabsOrientation();

    return () => window.removeEventListener("resize", handleTabsOrientation);
  }, [tabsOrientation]);

  useEffect(() => {
    const fetchBranches = async () => {
      // setCirleLoading(true);
      try {
        const fields = [
          "id",
          "name",
          "description",
          "address",
          "state",
          "zipCode",
          "branchIncharge",
        ];
        const data = await fetchAll("Branch", fields);
        let result = data?.allBranch;
        let filterdata = result.map((val) => {
          return {
            value: val.id,
            label: val.name,
          };
        });
        setbranchOptions(filterdata);
      } catch (error) {
        console.error("Error fetching branches:", error);
      } finally {
        // setCirleLoading(false);
      }
    };

    fetchBranches();

    const fetchShifts = async () => {
      try {
        const response = await axios.post(
          BASEURL,
          {
            query: `query { allShifts { id name } }`,
          },
          { headers: { "Content-Type": "application/json" } },
        );
        const result = response.data.data.allShifts;
        setShiftOptions(
          result.map((val) => ({ value: val.name, label: val.name })),
        );
      } catch (error) {
        console.error("Error fetching shifts:", error);
      }
    };
    fetchShifts();

    const fetchCategories = async () => {
      try {
        const data = await fetchAll("Category", ["id", "name"]);
        const result = data?.allCategory || [];
        setcategoriesOptions(
          result.map((val) => ({ value: val.name, label: val.name })),
        );
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };
    fetchCategories();
  }, []);

  const employeeListTable = {
    columns: [
      {
        field: "empid",
        headerName: "Employee Id",
        width: 150,
        disableColumnMenu: true,
        editable: false,
        sortable: true,
      },
      {
        field: "firstName",
        headerName: "User Name",
        width: 150,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },
      {
        field: "contactNumber",
        headerName: "Contact Number",
        width: 150,
        disableColumnMenu: true,
        editable: false,
        sortable: true,
      },
      {
        field: "role",
        headerName: "Role",
        width: 150,
        disableColumnMenu: true,
        editable: false,
        sortable: true,
      },

      {
        field: "branch",
        headerName: "Branch",
        width: 150,
        disableColumnMenu: true,
        editable: false,
        sortable: true,
      },
      {
        field: "shift",
        headerName: "Shift",
        width: 170,
        disableColumnMenu: true,
        editable: false,
        sortable: true,
      },
      {
        field: "employeeType",
        headerName: "Employee Type",
        width: 150,
        disableColumnMenu: true,
        editable: false,
        sortable: true,
      },
      {
        field: "employeeCategory",
        headerName: "Employee Category",
        width: 170,
        disableColumnMenu: true,
        editable: false,
        sortable: true,
      },
    ],

    rows: employeeList.map((performance) => {
      const role = roledata?.find((r) => r.id == performance?.role?.id);
      return {
        id: performance.id,
        empid: performance.empid,
        firstName: performance.firstName + " " + performance?.lastName,

        contactNumber: performance.contactNumber,

        role: role?.role,
        branch: performance?.branch || "-",
        shift: performance?.shift || "-",
        employeeType: performance?.employeeType,
        employeeCategory: performance?.category,
      };
    }),
  };

  const handleNewEmployee = () => {
    setEmpSubmit(false);

    navigate("/employee-management/add-employee");
  };

  const handlefilter = (event, name) => {
    const state = event.map((day) => day.label);
    if (name === "categories") {
      setcategories(state);
    } else if (name === "shifts") {
      setShifts(state);
    } else if (name === "employeeTypes") {
      setEmployeeTypes(state);
    } else {
      setbranches(state);
    }
  };

  const onEmployeeListClick = (e) => {
    setEmpSubmit(true);
    if (e?.id) {
      navigate(`/employee-management/add-employee?id=${e?.id}`);
    }
  };
  const getroles = async () => {
    const query = `query{
   allRoles{
     data{
       id
       role
       description
     }
   }
 }`;
    try {
      const response = await axios.post(
        BASEURL,
        {
          query: query,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      const wfhList = response.data.data.allRoles[0]?.data;
      setroledata(wfhList);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const onEmployeeeSubmit = async () => {
    const query = `
      query allUsersDetailWithPagination(
  $categories: [String]
  $branches: [String]
  $shifts: [String]
  $employeeTypes: [String]
  $page: Int
  $pageSize: Int
  $search: String
) {
  allUsersDetailWithPagination(
    categories: $categories
    branches: $branches
    shifts: $shifts
    employeeTypes: $employeeTypes
    page: $page
    pageSize: $pageSize
    search: $search
  ) {
    success
    message
 
    data {
        id
        firstName
        lastName
        fathersName
        dateOfBirth
        email
        gender
        username
        empid
        contactNumber
        secondaryContactNumber
        aadharNumber
        panNumber
        employeeType
        category
        branch
        maritalStatus
        address
        country
        state
        city
        zipCode
        dateOfJoining
        LastWorkingDay
        otApplicable
        shift
        esicNumber
        uanNumber
        memberId
        isUser
        isActive
      isSuperuser
        role {
          id
        }
        bankDetails {
          accountNumber
          bankName
          ifscNumber
          branchName
          cifNumber
        }
        salaryDetails {
          basicAmount
          daAmount
          mealsAmountPerDay
          otAmountPerHour
          shiftPaisa
          attendanceAmount
          busFare
        }
        aadharAttachment 
        nomineeAadharAttachment 
        panAttachment 
        bankPassbookAttachment 
        nomineeName 
        nomineeRelationship 
    }
 
    pagination {
      totalCount
      currentPage
      totalPages
      hasNextPage
      hasPreviousPage
    }
  }
}
   `;

    try {
      setPageState({ ...pageState, loading: true });

      const response = await axios.post(
        BASEURL,
        {
          query: query,
          variables: {
            categories: categories,
            branches: branches,
            shifts: shifts,
            employeeTypes: employeeTypes,
            page: paginationModel?.page + 1,
            search: emplyoee,
          },
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      // Ensure response structure is correct
      if (
        response.data &&
        response.data.data &&
        response.data.data.allUsersDetailWithPagination
      ) {
        const empList = response.data.data.allUsersDetailWithPagination?.data;
        const totalcount =
          response.data.data.allUsersDetailWithPagination?.pagination
            ?.totalCount;

        setTotalCount(Number(totalcount));

        // Filter out employees where empid is empty/null
        const filteredData = empList.filter((val) => !val.isSuperuser);

        // Update state
        setEmployeeList(filteredData);
        setPageState({ ...pageState, loading: false, state: "success" });
      } else {
        throw new Error("Invalid response structure from API");
      }
    } catch (error) {
      console.error("Error fetching employee list:", error);
      setPageState({
        ...pageState,
        loading: false,
        error: true,
        message: error.message,
      });
    }
  };

  return (
    <DashboardLayout>
      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                  Employee Management List
                </MaterialTypography>
              </Stack>

              {AccessData &&
                Array.isArray(AccessData) &&
                AccessData.some(
                  (item) => item.component === "AddEmployee" && item.can_access,
                ) && (
                  <MaterialButton
                    variant="gradient"
                    color="dark"
                    size="small"
                    startIcon={<AddIcon />}
                    onClick={() => handleNewEmployee()}
                  >
                    Employee
                  </MaterialButton>
                )}
            </Stack>
          }
        />
        <Grid2 size={{ xs: 12, md: 12, lg: 12 }} container spacing={1} p={1}>
          <Grid2 size={{ xs: 12, md: 6, lg: 3 }}>
            <MaterialBox lineHeight={0} display="inline-block">
              <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Categories
              </MaterialTypography>
            </MaterialBox>
            <Autocomplete
              multiple
              options={categoriesOptions.filter(
                (option) => !categories?.includes(option.value),
              )}
              value={categories.map((day) => ({
                value: day,
                label: day,
              }))}
              onChange={(event, newValue) =>
                handlefilter(newValue, "categories")
              }
              getOptionLabel={(option) => option.label}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  placeholder="Choose Categories"
                />
              )}
            />
          </Grid2>

          <Grid2 size={{ xs: 12, md: 6, lg: 3 }}>
            <MaterialBox lineHeight={0} display="inline-block">
              <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Branches
              </MaterialTypography>
            </MaterialBox>
            <Autocomplete
              multiple
              disabled={isBranchAdmin}
              options={branchOptions.filter(
                (option) => !branches.includes(option.label),
              )}
              value={branches.map((day) => ({
                value: day,
                label: day,
              }))}
              onChange={(event, newValue) => handlefilter(newValue, "branches")}
              getOptionLabel={(option) => option.label}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  placeholder="Choose Branches"
                />
              )}
            />
          </Grid2>

          <Grid2 size={{ xs: 12, md: 6, lg: 3 }}>
            <MaterialBox lineHeight={0} display="inline-block">
              <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Shifts
              </MaterialTypography>
            </MaterialBox>
            <Autocomplete
              multiple
              options={shiftOptions.filter(
                (option) => !shifts.includes(option.label),
              )}
              value={shifts.map((s) => ({
                value: s,
                label: s,
              }))}
              onChange={(event, newValue) => handlefilter(newValue, "shifts")}
              getOptionLabel={(option) => option.label}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  placeholder="Choose Shifts"
                />
              )}
            />
          </Grid2>

          <Grid2 size={{ xs: 12, md: 6, lg: 3 }}>
            <MaterialBox lineHeight={0} display="inline-block">
              <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Employee Type
              </MaterialTypography>
            </MaterialBox>
            <Autocomplete
              multiple
              options={employeeTypeOptions.filter(
                (option) => !employeeTypes.includes(option.label),
              )}
              value={employeeTypes.map((t) => ({
                value: t,
                label: t,
              }))}
              onChange={(event, newValue) =>
                handlefilter(newValue, "employeeTypes")
              }
              getOptionLabel={(option) => option.label}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  placeholder="Choose Employee Type"
                />
              )}
            />
          </Grid2>

          <Grid2 size={{ xs: 12, md: 6, lg: 3 }}>
            <MaterialBox lineHeight={0} display="inline-block">
              <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Search
              </MaterialTypography>
            </MaterialBox>
            <MaterialInput
              name="startDate"
              type="text"
              placeholder="Enter Employee Search"
              onChange={(e) => setEmployee(e.target.value)}
            />
          </Grid2>
        </Grid2>

        <MaterialDataGrid
          customHeight={550}
          paginationModel={paginationModel}
          setPaginationModel={setPaginationModel}
          rowCount={totalCount}
          rows={employeeListTable.rows}
          columns={employeeListTable.columns}
          checkboxSelection={false}
          isSelectable={true}
          onRowClick={onEmployeeListClick}
          loading={pageState.loading}
          localeText={{
            noRowsLabel: (
              <Stack
                direction="column"
                alignItems="center"
                justifyContent="center"
                spacing={1}
              >
                <MaterialTypography
                  variant="body2"
                  fontWeight="medium"
                  color="text"
                >
                  No employee found
                </MaterialTypography>
                <MaterialTypography variant="caption" color="text">
                  You have not yet added any employee details. Click on the "Add
                  Employee" button to start adding employee details.
                </MaterialTypography>
              </Stack>
            ),
          }}
        />
      </Card>
    </DashboardLayout>
  );
};

export default EmployeeManagement;
